export default __webpack_public_path__ + "static/media/guard4.5e87f00d.png";